/**
 * Public favicon URL for a normal https page (used for chat link previews).
 * Domain-based; no API key.
 */
export function getRemoteFaviconUrl(pageUrl) {
    try {
        const u = new URL(pageUrl);
        const host = u.hostname;
        if (!host) return '';
        return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=64`;
    } catch {
        return '';
    }
}
